import { useReframe } from 'nike-re-framejs';
import React, { useState } from 'react';

import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import RadioButton from '@/common/components/RadioButton';
import i18n from '@i18n';
import { navigate } from '@/routing';
import { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';

export function CountryListDialog({ data }) {
    const { sportSlugPart, currentSlug } = data;
    const derefSub = useReframe();
    const [countrySlugPart, setCountrySlugPart] = useState(currentSlug && currentSlug.get('slug').split('/')[2]);
    const countryList = derefSub(['nikeone.countryList', sportSlugPart]);

    function handleClick(countrySlugPart) {
        navigate(CURRENT_PAGE, { sportSlugPart, countrySlugPart });
        setCountrySlugPart(countrySlugPart);
        setTimeout(() => PopupNg.dispatcher.close('nikeone/country-filter'), 500);
        fireGAEvent(CURRENT_PAGE, 'Krajina', 'Filter');
    }

    return (
        <>
            <DialogTitle>
                <h2>{i18n('filter.title.offer.country')}</h2>
            </DialogTitle>
            <DialogBody className="country-list">
                <RadioButton active={!countrySlugPart} onClick={() => handleClick()}>
                    {i18n('cms.countries.all')}
                </RadioButton>
                {countryList.map(item => {
                    const itemCountrySlugPart = item.get('slug').split('/')[2];
                    return (
                        <RadioButton
                            active={countrySlugPart && countrySlugPart === itemCountrySlugPart}
                            onClick={() => handleClick(itemCountrySlugPart)}
                            key={itemCountrySlugPart}
                        >
                            {item.get('label')}
                        </RadioButton>
                    );
                })}
            </DialogBody>
        </>
    );
}

export default CountryListDialog;
